import moment from 'moment';
import { useState } from 'react';
import { Timezone } from '../pages/Dashboard/PerformanceDashboard/DashboardTimezoneModal';

export function useTimezoneDialog() {
  const [isOpen, setOpen] = useState(false);
  const [timezone, setTimezone] = useState<Timezone>({
    value: moment.tz.guess(),
    label: moment.tz.guess(),
  });

  return {
    isOpen,
    timezone,
    setOpen,
    setTimezone,
  };
}
